/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/callback',
    layout: false,
    component: './callback',
  },
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
      },
      {
        name: 'accessDenied',
        path: '/user/access-denied',
        component: './user/access-denied',
      },
    ],
  },
  // P-01 运行看板
  {
    path: '/dashboard',
    name: 'dashboard',
    icon: 'dashboard',
    component: './Dashboard',
  },
  // 接入管理 (P-02 ~ P-05)
  {
    path: '/access',
    name: 'access',
    icon: 'api',
    routes: [
      {
        path: '/access',
        redirect: '/access/partners',
      },
      {
        path: '/access/partners',
        name: 'partners',
        component: './Access/Partners',
      },
      {
        // 联调测试报告（可打印存档）
        path: '/access/partners/:partnerId/test-report',
        name: 'partnerTestReport',
        hideInMenu: true,
        component: './Access/Partners/TestReport',
      },
      {
        path: '/access/partners/:partnerId',
        name: 'partnerDetail',
        hideInMenu: true,
        component: './Access/Partners/Detail',
      },
      {
        path: '/access/agreements',
        name: 'agreements',
        component: './Access/Agreements',
      },
      {
        path: '/access/channels',
        redirect: '/access/profiles',
      },
      {
        path: '/access/connections',
        redirect: '/workflow/connections',
      },
      {
        path: '/access/profiles',
        name: 'profiles',
        component: './Access/Profiles',
      },
      {
        path: '/access/certificates',
        name: 'certificates',
        component: './Access/Certificates',
      },
    ],
  },
  // 报文标准 (P-06 ~ P-10)
  {
    path: '/standards',
    name: 'standards',
    icon: 'fileText',
    routes: [
      {
        path: '/standards',
        redirect: '/standards/library',
      },
      {
        path: '/standards/library',
        name: 'library',
        component: './Standards/Library',
      },
      {
        path: '/standards/library/:standardId',
        name: 'standardDetail',
        hideInMenu: true,
        component: './Standards/Library/Detail',
      },
      {
        path: '/standards/dictionaries',
        name: 'dictionaries',
        component: './Standards/Dictionaries',
      },
      {
        path: '/standards/documents',
        name: 'documents',
        component: './Standards/Documents',
      },
      {
        path: '/standards/documents/:documentId',
        name: 'documentDetail',
        hideInMenu: true,
        component: './Standards/Documents/Detail',
      },
      {
        path: '/standards/mapping',
        name: 'mapping',
        component: './Standards/Mapping',
      },
      {
        path: '/standards/mapping/:mappingId',
        name: 'mappingDesigner',
        hideInMenu: true,
        component: './Standards/Mapping/Designer',
      },
    ],
  },
  // 工作流 (端口连成的处理链路)
  {
    path: '/workflow',
    name: 'workflow',
    icon: 'branches',
    routes: [
      {
        path: '/workflow',
        name: 'flows',
        component: './Workflow',
      },
      {
        // 业务流程投递到内部系统时使用的数据库 / FTP / SFTP 连接（与伙伴无关，不放在接入管理）
        path: '/workflow/connections',
        name: 'connections',
        component: './Access/Connections',
      },
      {
        path: '/workflow/:flowId',
        name: 'detail',
        hideInMenu: true,
        component: './Workflow/Detail',
      },
    ],
  },
  // 报文中心 (P-11, P-13, P-22, P-23, P-12)
  // 注意：/messages/documents、/messages/batch、/messages/archive 必须全部声明在 /messages/:messageId 之前！
  {
    path: '/messages',
    name: 'messages',
    icon: 'message',
    routes: [
      {
        path: '/messages',
        name: 'query',
        component: './Messages',
        exact: true,
      },
      {
        path: '/messages/interchanges',
        name: 'interchanges',
        component: './Messages/Interchanges',
      },
      {
        path: '/messages/documents',
        name: 'documents',
        component: './Messages/Documents',
      },
      {
        path: '/messages/batch',
        name: 'batch',
        component: './Messages/Batch',
      },
      {
        path: '/messages/archive',
        name: 'archive',
        component: './Messages/Archive',
      },
      {
        path: '/messages/:messageId',
        name: 'detail',
        hideInMenu: true,
        component: './Messages/Detail',
      },
    ],
  },
  // 监控预警 (P-14 ~ P-16)
  {
    path: '/alerts',
    name: 'alerts',
    icon: 'alert',
    routes: [
      {
        path: '/alerts',
        redirect: '/alerts/events',
      },
      {
        path: '/alerts/events',
        name: 'events',
        component: './Alerts/Events',
      },
      {
        path: '/alerts/rules',
        name: 'rules',
        component: './Alerts/Rules',
      },
      {
        path: '/alerts/workorders',
        name: 'workorders',
        component: './Alerts/Workorders',
      },
      {
        path: '/alerts/knowledge',
        name: 'knowledge',
        component: './Alerts/Knowledge',
      },
    ],
  },
  // 模拟工具 (P-17 ~ P-19)
  {
    path: '/simulator',
    name: 'simulator',
    icon: 'tool',
    routes: [
      {
        path: '/simulator',
        redirect: '/simulator/diagnose',
      },
      {
        path: '/simulator/mock',
        name: 'mock',
        component: './Simulator/Mock',
      },
      {
        path: '/simulator/diagnose',
        name: 'diagnose',
        component: './Simulator/Diagnose',
      },
    ],
  },
  // 审计合规 (P-20 ~ P-21)
  {
    path: '/audit',
    name: 'audit',
    icon: 'safetyCertificate',
    routes: [
      {
        path: '/audit',
        redirect: '/audit/logs',
      },
      {
        path: '/audit/logs',
        name: 'logs',
        component: './Audit/Logs',
      },
      {
        path: '/audit/reports',
        name: 'reports',
        component: './Audit/Reports',
      },
    ],
  },
  // 系统设置 (模板自带)
  {
    path: '/settings',
    name: 'settings',
    icon: 'setting',
    access: 'tenantAdmin',
    routes: [
      {
        path: '/settings',
        redirect: '/settings/permissions',
      },
      {
        path: '/settings/permissions',
        name: 'permissions',
        access: 'tenantAdmin',
        component: './Permissions',
      },
      {
        path: '/settings/model-settings',
        name: 'modelSettings',
        access: 'modelSettings',
        component: './ModelSettings',
      },
    ],
  },
  // 重定向到运行看板
  {
    path: '/home',
    redirect: '/dashboard',
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
